/** Joins class names, filtering falsy values. */
export const cn = (
  ...classes: (string | false | null | undefined)[]
): string => classes.filter(Boolean).join(" ");
